import {
  projectBg,
  projectBg2,
  projectBg5,
  projectBg6,
  projectBg7,
  projectBg8,
  projectBg9,
  projectBg10,
  projectBg11,
  projectBg12,
  shots,
  shots2,
  shots3,
  projectGoDashboard,
  projectOpenview,
  projectHomeFurniture,
  projectSelera,
  projectVanta,
  projectXiom,
  projectSand,
  projectTalka,
  projectCare,
  projectOnego,
  projectOnego1,
  shots4,
  kickoffzone,
  cssOnly,
  T3dOnly,
} from "../assets/index";
import SlideThrough from "../components/shots/SlideThrough";
import BouncyBallz from "../components/shots/BouncyBallz";
import WoodenIrfan from "../components/shots/WoodenIrfan";
import Hippo from "../components/shots/Hippo";

export const projectListData = [
  {
    key: 8,
    name: "OneGo",
    image: projectBg12,
    tags: ["Super App", "Mobile App", "Finance", "UI/UX", "Research"],
    content:
      "OneGo is an AI-powered super app built for Malaysia. It puts everyday money and lifestyle tasks in one place: paying, transferring, bills, transport, travel and bookings.",
    date: "09/10/2026",
    projectDetail: {
      intro: {
        title: "Project Introduction",
        content:
          "OneGo is an AI-powered super app built for Malaysia. It puts everyday money and lifestyle tasks in one place: paying, transferring, bills, transport, travel and bookings.",
        bullets: "bullets",
        bigAttachment: [projectOnego, projectOnego1],
        description: "description",
      },
    },
  },
  {
    key: 7,
    name: "Care",
    image: projectBg11,
    tags: ["Mobile App", "Healthcare", "UI/UX Design", "UX Research"],
    content:
      "Find a specialist, book appointments, and manage your health with ease. Care is a private messaging app for one-to-one and group conversation voice notes, threaded replies, reactions, scheduled sends and disappearing messages, all end-to-end encrypted.",
    date: "06/10/2026",
    projectDetail: {
      intro: {
        title: "Project Introduction",
        content:
          "Find a specialist, book appointments, and manage your health with ease. Care is a private messaging app for one-to-one and group conversation voice notes, threaded replies, reactions, scheduled sends and disappearing messages, all end-to-end encrypted.",
        bullets: "bullets",
        bigAttachment: projectCare,
        description: "description",
      },
    },
  },
  {
    key: 7,
    name: "Talka",
    image: projectBg10,
    tags: ["Mobile App", "Messaging", "UI/UX Design", "UX Research"],
    content:
      "Talka is a private messaging app for one-to-one and group conversation voice notes, threaded replies, reactions, scheduled sends and disappearing messages, all end-to-end encrypted.",
    date: "17/09/2026",
    projectDetail: {
      intro: {
        title: "Project Introduction",
        content:
          "Talka is a private messaging app for one-to-one and group conversation voice notes, threaded replies, reactions, scheduled sends and disappearing messages, all end-to-end encrypted.",
        bullets: "bullets",
        bigAttachment: projectTalka,
        description: "description",
      },
    },
  },
  {
    key: 6,
    name: "Xiom",
    image: projectBg9,
    tags: ["Web App", "CRM", "UI/UX Design", "UX Research"],
    content:
      "A CRM that adapts to your business. Start with a working CRM, then reshape the data, screens and automations to match how you actually work without writing code.",
    date: "1/09/2026",
    projectDetail: {
      intro: {
        title: "Project Introduction",
        content:
          "A CRM that adapts to your business. Start with a working CRM, then reshape the data, screens and automations to match how you actually work without writing code.",
        bullets: "bullets",
        bigAttachment: projectXiom,
        description: "description",
      },
    },
  },
  {
    key: 5,
    name: "Vanta",
    image: projectBg8,
    tags: ["Mobile App", "UI/UX Design", "UX Research"],
    content:
      "Vanta is a multi-chain, non-custodial digital asset platform that allows users to connect multiple wallets, view their combined portfolio, discover digital assets.",
    date: "1/09/2026",
    projectDetail: {
      intro: {
        title: "Project Introduction",
        content:
          "Vanta is a multi-chain, non-custodial digital asset platform that allows users to connect multiple wallets, view their combined portfolio, discover digital assets.",
        bullets: "bullets",
        bigAttachment: projectVanta,
        description: "description",
      },
    },
  },
  {
    key: 4,
    name: "Selera",
    image: projectBg7,
    tags: ["Mobile App", "UI/UX Design", "UX Research"],
    content:
      "Serela is a smart meal planning and grocery management app designed for busy families who want to eat well without overspending. The app simplifies the weekly routine of planning meals, building shopping lists, and managing household grocery needs — all in one shared space.",
    date: "26/08/2026",
    projectDetail: {
      intro: {
        title: "Project Introduction",
        content:
          "Serela is a smart meal planning and grocery management app designed for busy families who want to eat well without overspending. The app simplifies the weekly routine of planning meals, building shopping lists, and managing household grocery needs — all in one shared space.",
        bullets: "bullets",
        bigAttachment: projectSelera,
        description: "description",
      },
    },
  },
  {
    key: 3,
    name: "Home Furniture",
    image: projectBg6,
    tags: ["Web App", "UI/UX Design", "UX Research"],
    content:
      "The Furniture Home project focuses on transforming the online furniture shopping experience through a comprehensive platform redesign.",
    date: "28/11/2024",
    projectDetail: {
      intro: {
        title: "Project Introduction",
        content:
          "The Furniture Home project focuses on transforming the online furniture shopping experience through a comprehensive platform redesign. With a vision to provide high-quality furniture and decor with seamless accessibility, the project addresses key challenges such as product discoverability, customer engagement, and checkout efficiency.",
        bullets: "bullets",
        bigAttachment: projectHomeFurniture,
        description: "description",
      },
    },
  },
  {
    key: 2,
    name: "OpenView",
    image: projectBg5,
    tags: ["Web App", "UI/UX Design", "UX Research"],
    content:
      "OpenView is an innovative NFT marketplace designed to simplify the buying and selling of digital assets.",
    date: "8/11/2024",
    projectDetail: {
      intro: {
        title: "Project Introduction",
        content:
          "OpenView is an innovative NFT marketplace designed to simplify the buying and selling of digital assets. The project focuses on creating a user-friendly and secure platform that empowers artists and collectors through streamlined processes, enhanced discoverability, and robust security measures. By prioritizing intuitive design and accessibility, OpenView aims to revolutionize the NFT trading experience.",
        bullets: "bullets",
        bigAttachment: projectOpenview,
        description: "description",
      },
    },
  },
  {
    key: 1,
    name: "Go Dashboard",
    image: projectBg,
    tags: ["Web App", "UI/UX Design", "UX Research", "UX Workshop"],
    content:
      "A real-time portal delivers comprehensive statistics and highlights from the gas and energy industries.",
    date: "1/1/2023",
    projectDetail: {
      intro: {
        title: "Project Introduction",
        content:
          "A real-time portal delivers comprehensive statistics and highlights from the gas and energy industries.",
        bullets: "bullets",
        bigAttachment: projectGoDashboard,
        description: "description",
      },
    },
  },
  {
    key: 0,
    name: "SAND",
    image: projectBg2,
    tags: ["Web App", "UI/UX Design", "UX Research"],
    content:
      "A platform for real-time sand monitoring and predictive analytics to provide a competitive advantage.",
    date: "1/1/2023",
    projectDetail: {
      intro: {
        title: "Project Introduction",
        content: `I conducted a UX discovery workshop for a project aimed at identifying the user needs and pain points. The project involved developing a web application. To start the workshop, I organized a meeting with stakeholders to understand their expectations and goals. Then, I identified the user groups and recruited participants who fit those groups.

          During the workshop, I used a combination of activities, such as persona mapping, customer journey mapping, and feature prioritization exercises to understand user behaviors, motivations, and pain points. I also organized a focus group discussion with the participants to gather qualitative feedback and to validate our findings.
          
          After conducting the workshop, I analyzed the data and created a report that summarized the key insights and recommendations. The report included personas, customer journey maps, and prioritized features. I also presented the findings to the stakeholders and the development team.
          
          The insights gained from the workshop provided the basis for the design and development of the web application, ensuring that the final product met the needs and expectations of the users. Through this UX discovery workshop, we were able to create a user-centered design, resulting in a more successful product.`,
        bullets: "bullets",
        bigAttachment: projectSand,
        description: "description",
      },
    },
  },
];

export const shotsData = [
  {
    key: 3,
    thumbnail: shots4,
    name: "Hippo",
    category: "Spline",
    component: <Hippo />,
  },
  {
    key: 2,
    thumbnail: shots3,
    name: "Wooden IQ",
    category: "Spline",
    component: <WoodenIrfan />,
  },
  {
    key: 1,
    thumbnail: shots2,
    name: "Bouncy Ballz",
    category: "Spline",
    component: <BouncyBallz />,
  },
  {
    key: 0,
    thumbnail: shots,
    name: "Slide Through",
    category: "Blender",
    component: <SlideThrough />,
  },
];

export const youtubeJourney = [
  {
    key: 0,
    thumbnail: kickoffzone,
    name: "KickOffZone",
    category: "Sports",
    channel: "https://www.youtube.com/@KickOff-Zone",
  },
  {
    key: 0,
    thumbnail: cssOnly,
    name: "CSSOnly",
    category: "Tech",
    channel: "https://www.youtube.com/@CssOnly",
  },
  {
    key: 0,
    thumbnail: T3dOnly,
    name: "3DOnly",
    category: "Tech",
    channel: "https://www.youtube.com/@3dsonly",
  },
];
